import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";
import { getMaintenanceState } from "@/utils/maintenance";

Vue.use(VueRouter)

const Home = () => import('@/views/home/Home.vue')
const Company = () => import('@/views/home/Company.vue')
import ProductSecondDetail from "@/views/home/product_show/productSecondDetail.vue";
import NewsSecondDetail from "@/views/home/brand_news/newsSecondDetail.vue";

const routes = [
    {
        path: '',
        redirect: '/home'
    },
    //首页
    {
        path:'/home',
        component:Home
    },
    //璟点台球集团
    {
        path:'/company',
        component:Company,
    },
    //导航栏品牌
    {
        //品牌下二级详情页面
        path:'/brand_cl',
        component: () => import('@/views/business/product/secondClassifyDetail.vue'),
    },
    {
        //品牌下三级详情页面
        path:'/third_cl',
        component: () => import('@/views/business/product/thirdClassifyDetail.vue'),
    },
    {
        //品牌下四级详情页面
        path:'/fourth_cl',
        component: () => import('@/views/business/product/fourthClassifyDetail.vue'),
    },
    {
        //品牌下球桌详情页面
        path:'/table',
        component: () => import('@/views/business/table/billiardTableDetail.vue'),
    },
    {
        //品牌下球桌详情页面
        path:'/table_sc',
        component: () => import('@/views/business/table/secondTableMain.vue'),
    },

    //赛事
    {
        path:'/contest',
        component: () => import('@/views/business/contest/index.vue'),
    },
    //社交平台
    {
        path:'/social',
        component: () => import('@/views/business/social/index.vue'),
    },
    //媒体中心
    {
        path:'/mediaNews',
        component: () => import('@/views/business/media/index.vue'),
    },

    //文章列表主页页面
    {
        path:'/articleHome',
        component: () => import('@/views/business/article/articleHome.vue'),
    },

    //文章详情页面
    {
        path:'/article',
        component: () => import('@/views/business/article/articleMain.vue'),
    },

    //球员预览页面
    {
        path:'/player',
        component: () => import('@/views/business/player/index.vue'),
    },
    //球员预览页面
    {
        path:'/playerDetail',
        component: () => import('@/views/business/player/detailIndex.vue'),
    },


    //产品展示二级详情页面
    {
        path:'/productDetail',
        component:ProductSecondDetail
    },

    //新闻中心二级详情页面
    {
        path:'/newsDetail',
        component:NewsSecondDetail
    },

    //页脚
    //俱乐部
    {
        path:'/club',
        component: () => import('@/views/business/club/index.vue'),
    },
    //加盟申请
    {
        path:'/join',
        component: () => import('@/views/business/join/index.vue'),
    },

    //各品牌官网路由
    {
        path:'/website',
        component: () => import('@/views/business/website/index.vue'),
    },
    //真伪查询页面
    {
        path:'/portal_check',
        component: () => import('@/views/business/portal_check/index.vue'),
    },
    /////////////////////////////////////移动端售后模块路由///////////////////////////////////////////////////////

    //登录页
    {
        path:'/sales_login',
        component: () => import('@/views/business/sales/salesLogin.vue'),
        meta: {
            requiresClearToken: true // 该路由需要清空Token
        }
    },
    //忘记密码验证码校验
    {
        path:'/sales_forget',
        component: () => import('@/views/business/sales/salesForgetPassword.vue'),
    },
    //重置密码
    {
        path:'/sales_resetPass',
        component: () => import('@/views/business/sales/salesResetPassword.vue'),
    },
    //注册页
    {
        path:'/sales_register',
        component: () => import('@/views/business/sales/salesRegister.vue'),
    },
    //首页
    {
        path:'/sales_home',
        component: () => import('@/views/business/sales/salesHome.vue'),
        meta: { requiresAuth: true }
    },
    //我的球杆
    {
        path:'/my_club',
        component: () => import('@/views/business/sales/myClubList.vue'),
        meta: { requiresAuth: true }
    },
    //我的权益
    {
        path:'/benefits',
        component: () => import('@/views/business/sales/myClubBenefits.vue'),
        meta: { requiresAuth: true }
    },
    //翻新/置换登记
    {
        path:'/benefits_register',
        component: () => import('@/views/business/sales/benefitsRegister.vue'),
        meta: { requiresAuth: true }
    },
    //球杆注册登记
    {
        path:'/sales_club_register',
        component: () => import('@/views/business/sales/clubRegister.vue'),
        meta: { requiresAuth: true }
    },
    //真伪查询
    {
        path:'/sales_search',
        component: () => import('@/views/business/sales/search.vue'),
        meta: { requiresAuth: true }
    },
    //售后申请
    {
        path:'/sales_after',
        component: () => import('@/views/business/sales/after.vue'),
        meta: { requiresAuth: true }
    },
    //售后进度
    {
        path:'/sales_step',
        component: () => import('@/views/business/sales/step.vue'),
        meta: { requiresAuth: true }
    },



    ///////新会员系统路由配置//////////////////////////////////////

    //销售-登录
    {
        path:'/sale_login',
        component: () => import('@/views/h5/sale/login.vue'),
    },

    //销售-注册
    {
        path:'/sale_activate_cue',
        // component: () => import('@/views/h5/activationCue.vue'),
        component: () => import('@/views/h5/sale/activationCue.vue'),
    },

    //销售-首页
    {
        path:'/sale_home',
        component: () => import('@/views/h5/sale/home.vue'),
        meta: { requiresAuth: true }
    },

    //销售-分销返利列表
    {
        path:'/sale_list',
        // component: () => import('@/views/h5/activationCue.vue'),
        component: () => import('@/views/h5/sale/saleList.vue'),
    },

    //代理商-销售管理列表
    {
        path:'/sale_manage',
        component: () => import('@/views/h5/saleManage.vue'),
        meta: { requiresAuth: true }
    },

    //代理商-新增销售
    {
        path:'/sale_manage_add',
        component: () => import('@/views/h5/saleManageAdd.vue'),
        meta: { requiresAuth: true }
    },

    //会员系统-登录
    {
        path:'/app_login',
        component: () => import('@/views/h5/login.vue'),
    },
    //会员系统-注册
    {
        path:'/activate_cue',
        // component: () => import('@/views/h5/activationCue.vue'),
        component: () => import('@/views/h5/activationCueNew.vue'),
    },
    //会员系统-个人中心-忘记密码
    {
        path:'/forgot_password',
        component: () => import('@/views/h5/forgotPassword.vue'),
    },
    //会员系统-首页
    {
        path:'/app_home',
        component: () => import('@/views/h5/home.vue'),
        meta: { requiresAuth: true }
    },
    //会员系统-真伪查询
    {
        path:'/app_search',
        component: () => import('@/views/h5/search.vue'),
        meta: { requiresAuth: true }
    },
    //会员系统-真伪查询
    {
        path:'/app_search_dls',
        component: () => import('@/views/h5/searchDls.vue'),
        meta: { requiresAuth: true }
    },
    //会员系统-售后进度
    {
        path:'/app_step',
        component: () => import('@/views/h5/step.vue'),
        meta: { requiresAuth: true }
    },
    //会员系统-售后申请
    {
        path:'/app_after',
        component: () => import('@/views/h5/after.vue'),
        meta: { requiresAuth: true }
    },
    //会员系统-售后申请
    {
        path:'/app_after_benefits',
        component: () => import('@/views/h5/benefitAfter.vue'),
        meta: { requiresAuth: true }
    },
    //会员系统-球杆激活
    {
        path:'/app_activation',
        component: () => import('@/views/h5/activation.vue'),
        meta: { requiresAuth: true }
    },
    //会员系统-我的球杆
    {
        path:'/app_myClub',
        component: () => import('@/views/h5/myclub.vue'),
        meta: { requiresAuth: true }
    },
    //会员系统-个人中心
    {
        path:'/app_mine',
        component: () => import('@/views/h5/mine.vue'),
        meta: { requiresAuth: true }
    },
    //会员系统-个人中心-修改
    {
        path:'/app_edit_info',
        component: () => import('@/views/h5/edit-info.vue'),
        meta: { requiresAuth: true }
    },

    //会员系统-个人中心-修改密码
    {
        path:'/edit_pass',
        component: () => import('@/views/h5/edit-pass.vue'),
        meta: { requiresAuth: true }
    },

    //会员系统-我的权益
    {
        path:'/app_benefits',
        component: () => import('@/views/h5/benefits.vue'),
        meta: { requiresAuth: true }
    },
    //会员系统-权益申请
    {
        path:'/benefits_use',
        component: () => import('@/views/h5/benefitsUse.vue'),
        meta: { requiresAuth: true }
    },

    //会员系统-扫码核销
    {
        path:'/app_scan',
        component: () => import('@/views/h5/scan.vue'),
        meta: { requiresAuth: true }
    },

    //会员系统-nfc
    {
        path:'/sales_fw',
        component: () => import('@/views/h5/sales_fw.vue'),
    },
    //会员系统-球杆解绑-代理商
    {
        path:'/unbind',
        component: () => import('@/views/h5/unbind.vue'),
    },
    //会员系统-球杆解绑-普通会员
    {
        path:'/user_unbind',
        component: () => import('@/views/h5/unbind.vue'),
    },

    //展会加盟填报
    {
        path:'/fair_join',
        component: () => import('@/views/h5/fairJoin.vue'),
    },

    //停机升级公告页（全站维护中时展示）
    {
        path:'/maintenance',
        component: () => import('@/views/maintenance/index.vue'),
    },

    /////////////////////////////////////移动端售后模块路由--结束///////////////////////////////////////////////////////
]

const router = new VueRouter({
  mode: 'history',
  routes
})

const MAINTENANCE_PATH = '/maintenance'

router.beforeEach((to, from, next) => {
    //停机维护中：全站拦截，统一跳转到停机升级公告页
    if (getMaintenanceState().enabled) {
        if (to.path === MAINTENANCE_PATH) {
            next()
        } else {
            next({ path: MAINTENANCE_PATH, replace: true })
        }
        return
    }
    //维护结束后：公告页不再可达，回到首页
    if (to.path === MAINTENANCE_PATH) {
        next({ path: '/home', replace: true })
        return
    }
    //处理外部系统（会员官网）携带token的免登录跳转：写入本地登录态后清掉URL参数
    if (to.query.token) {
        store.dispatch('setToken', to.query.token)
        const query = { ...to.query }
        delete query.token
        next({ path: to.path, query, replace: true })
        return
    }
    //处理sales_login的Token清空逻辑
    if (to.meta.requiresClearToken) {
        // 调用Vuex的logout action，清空Token（Vuex+Cookie）
        store.dispatch('logout')
    }
    if (to.meta.requiresAuth) {
        if (store.getters.isLogin) {
            next()
        } else {
            next({ path: '/app_login', query: { redirect: to.fullPath } })
        }
    } else {
        if (to.path === '/app_login' && store.getters.isLogin) {
            next('/app_home')
        } else {
            next()
        }
    }
})

export default router